
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import type { ElForm } from "element-plus";

type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  setup() {
    onMounted(() => {
      if (!route.params.id) {
        setCurrentPageBreadcrumbs("合成分类新增", ["合成分类;compound_categories"]);
      } else {
        setCurrentPageBreadcrumbs("合成分类编辑", [
          "合成分类;compound_categories",
          route.params.id.toString(),
        ]);
      }
    });

    const rules = ref({
      name: [
        {
          required: true,
          message: "名称不可为空",
          trigger: "change",
        },
      ],
    });

    const formRef = ref<FormInstance>();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const compound_category = ref({
      name: "",
      sorting: 0,
      enabled: false,
      compound_type: "product",
      image: "",
      image_url: "",
    } as any);

    const onCancel = () => {
      router.push({ name: "compound_categories" });
    };

    const isNew = !route.params.id;

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          if (isNew) {
            store
              .dispatch(
                Actions.CREATE_COMPOUND_CATEGORY,
                compound_category.value
              )
              .then(() => {
                router.push({ name: "compound_categories" });
              })
              .catch((errorMsg) => {
                Swal.fire({
                  text: errorMsg || "操作失败",
                  icon: "error",
                  confirmButtonText: "确认",
                });
              });
          } else {
            store
              .dispatch(Actions.UPDATE_COMPOUND_CATEGORY, {
                id: route.params.id,
                values: compound_category.value,
              })
              .then(() => {
                router.push({ name: "compound_categories" });
              })
              .catch((errorMsg) => {
                Swal.fire({
                  text: errorMsg || "操作失败",
                  icon: "error",
                  confirmButtonText: "确认",
                });
              });
          }
        } else {
          return false;
        }
      });
    };

    if (!isNew) {
      store
        .dispatch(Actions.GET_COMPOUND_CATEGORY, route.params.id)
        .then(() => {
          compound_category.value = store.getters.currentCompoundCategory;

          imageUrl.value =
            compound_category.value.image_url &&
            compound_category.value.image_url.startsWith("http")
              ? compound_category.value.image_url
              : "";
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {});
    }

    const imageUrl = ref("");

    const onChange = (file) => {
      var reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        imageUrl.value = e.target?.result?.toString() || "";
        compound_category.value.image = imageUrl.value;
      };
    };

    return {
      onSubmit,
      compound_category,
      rules,
      onCancel,
      formRef,
      onChange,
      imageUrl,
    };
  },
});
